<mat-form-field appearance="fill" color="primary" class="w-100">
  @if (control().hasLabel) {
    <mat-label [style.color]="control().labelColour">{{ control().label }}</mat-label>
  }
  <textarea matInput appTextareaJumptext appTextareaAutosize [style.color]="control().valueColour" [(ngModel)]="control().value" (ngModelChange)="onModelChanged()" [rows]="5"></textarea>
</mat-form-field>
